import { getRuleFiltersConfigBySection } from '@kw/quokka-ui';
import { FiltersAndTable } from '../FiltersAndTable';
import { OrgPolicyResults } from '../types/ApplicationDetailsType';

interface IProps {
  ruleSummaries: object;
  analysisId: string;
  section?: 'overview' | 'permission' | 'behaviors' | 'malicious' | '';
  customRules?: object;
  refresh?: () => void; // when we want to refresh the custom rules data after a review action
  policyViolations?: OrgPolicyResults[];
}

export const RulesTab = ({ ruleSummaries, analysisId, section = 'overview', customRules, policyViolations, refresh }: IProps) => {
  return (
    <FiltersAndTable analysisId={analysisId} data={ruleSummaries} customRules={customRules} policyViolations={policyViolations} refresh={refresh} filterSection={section} />
  );
};
